export default ({ width }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 194.432 39.082" {...{ width }}>
      <g id="Grupo_3" data-name="Grupo 3" transform="translate(-133.184 -110.059)">
        <g id="Grupo_1" data-name="Grupo 1">
          <path
            id="Caminho_1"
            data-name="Caminho 1"
            d="M176.246,130.328c0,5.62,4.141,9.8,10.019,9.8a10.249,10.249,0,0,0,7.469-3l-1.442-2.625a8.479,8.479,0,0,1-5.768,2.514,6.48,6.48,0,0,1-6.618-6.729,6.372,6.372,0,0,1,6.507-6.654,7.576,7.576,0,0,1,5.176,2.144l1.7-2.514a9.473,9.473,0,0,0-7.025-2.736A9.619,9.619,0,0,0,176.246,130.328Z"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Caminho_2"
            data-name="Caminho 2"
            d="M197.176,134.58c0,4.695,2.994,5.25,5.028,5.25a10.075,10.075,0,0,0,1.183-.074v-3.179a5.867,5.867,0,0,1-.629.036c-1.109,0-2-.406-2-2.661V113.581h-3.586Z"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Caminho_3"
            data-name="Caminho 3"
            d="M206.755,117.241h3.624v-3.66h-3.624v3.66Zm.037,22.441h3.587V120.975h-3.587Z"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Caminho_4"
            data-name="Caminho 4"
            d="M234.968,139.682h3.586v-8.8h2.7l5.62,8.8h4.178l-6.914-10.389v-.074l6.211-8.245h-4.067l-5.1,6.877h-2.625V113.581h-3.586Z"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Caminho_5"
            data-name="Caminho 5"
            d="M214.111,130.328c0,5.62,4.141,9.8,10.019,9.8a10.245,10.245,0,0,0,7.468-3l-1.442-2.625a8.475,8.475,0,0,1-5.767,2.514,6.48,6.48,0,0,1-6.618-6.729,6.372,6.372,0,0,1,6.507-6.654,7.576,7.576,0,0,1,5.176,2.144l1.7-2.514a9.473,9.473,0,0,0-7.025-2.736A9.619,9.619,0,0,0,214.111,130.328Z"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Caminho_6"
            data-name="Caminho 6"
            d="M234.908,146.881a2.209,2.209,0,0,0,2.312,2.26,2.363,2.363,0,0,0,1.723-.691l-.332-.6a1.956,1.956,0,0,1-1.331.58,1.5,1.5,0,0,1-1.527-1.553,1.471,1.471,0,0,1,1.5-1.536,1.75,1.75,0,0,1,1.2.495l.392-.58a2.185,2.185,0,0,0-1.621-.631,2.219,2.219,0,0,0-2.312,2.261Zm4.923.981c0,1.083.691,1.211,1.16,1.211a2.334,2.334,0,0,0,.273-.017v-.733a1.4,1.4,0,0,1-.145.008c-.256,0-.461-.094-.461-.614v-4.7h-.827v4.846Zm2.252-.376c0,1.143.5,1.655,1.476,1.655a1.741,1.741,0,0,0,1.587-.989h.017a2.821,2.821,0,0,0-.017.315v.572h.8v-4.317h-.827v2.022a1.487,1.487,0,0,1-1.4,1.63c-.691,0-.81-.478-.81-1.075v-2.577h-.828v2.764Zm5.162,1.553h.785v-.316a2.917,2.917,0,0,0-.017-.324h.017a1.551,1.551,0,0,0,1.356.742,2.023,2.023,0,0,0,1.963-2.26c0-1.34-.734-2.261-1.894-2.261a1.523,1.523,0,0,0-1.382.733h-.017s.017-.153.017-.366v-1.971h-.828v6.023Zm.8-2.141c0-1.1.6-1.553,1.246-1.553.716,0,1.22.606,1.22,1.544,0,.981-.563,1.544-1.246,1.544C248.448,148.433,248.047,147.665,248.047,146.9Z"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Caminho_7"
            data-name="Caminho 7"
            d="M159.958,113.4l3.033,3.034-8.8,7.554L152.4,122.2l7.555-8.8Zm-14.637,15.882,1.789,1.789-7.556,8.8-3.032-3.032,8.8-7.556Zm6.58-19.219-.881,11.564h-2.529l-.879-11.564ZM147.11,122.2l-1.789,1.788-8.8-7.554,3.033-3.034,7.555,8.8Zm7.654,3.171,11.565-.881v4.289l-11.566-.879v-2.529Zm-2.361,5.7,1.788-1.789,8.8,7.556-3.032,3.032-7.556-8.8Zm-3.911.572h2.529l.88,11.565h-4.289l.88-11.565Zm-3.743-6.272V127.9l-11.566.879v-4.289Z"
            fill="#fff"
            fillRule="evenodd"
          />
        </g>
        <path
          id="Caminho_8"
          data-name="Caminho 8"
          d="M285.005,118.5a2.918,2.918,0,0,0,2.965,3.031,3.11,3.11,0,0,0,2.251-.92l-.435-.583a2.623,2.623,0,0,1-1.791.756,2.177,2.177,0,0,1-2.152-2.292,2.108,2.108,0,0,1,2.144-2.218,2.644,2.644,0,0,1,1.675.632l.4-.608a2.988,2.988,0,0,0-2.111-.763,2.894,2.894,0,0,0-2.949,2.965Zm6.161,2.933h.8v-1.7a2.521,2.521,0,0,1,.1-.747,1.262,1.262,0,0,1,1.167-.978,1.135,1.135,0,0,1,.23.025v-.789a1.456,1.456,0,0,0-.205-.016,1.421,1.421,0,0,0-1.315,1.084h-.016a3.069,3.069,0,0,0,.016-.312v-.723h-.772v4.157Zm3.072-4.987h.8v-.813h-.8v.813Zm.009,4.987h.8v-4.157h-.8v4.157Zm1.708-1.167a1.3,1.3,0,0,0,1.413,1.265,1.438,1.438,0,0,0,1.331-.821h.016a3.191,3.191,0,0,0-.016.329v.394h.739v-2.629a1.477,1.477,0,0,0-1.643-1.627,2.6,2.6,0,0,0-1.552.493l.328.584a2.109,2.109,0,0,1,1.159-.4.807.807,0,0,1,.911.912v.074h-.18c-.7,0-2.506.057-2.506,1.429Zm.805-.041c0-.747,1.085-.788,1.684-.788h.206v.131a1.26,1.26,0,0,1-1.109,1.322.7.7,0,0,1-.781-.665Zm3.6-.871c0,1.29.707,2.177,1.832,2.177a1.456,1.456,0,0,0,1.364-.772h.017s-.009.115-.009.28v.394h.756v-5.8h-.8v1.922a2.3,2.3,0,0,0,.017.28h-.017a1.382,1.382,0,0,0-1.281-.658,1.939,1.939,0,0,0-1.882,2.177Zm.814,0c0-.944.542-1.487,1.2-1.487.789,0,1.175.74,1.175,1.479,0,1.06-.583,1.5-1.2,1.5-.691,0-1.175-.583-1.175-1.487Zm4.091-.008a2.244,2.244,0,1,0,2.243-2.169,2.177,2.177,0,0,0-2.243,2.169Zm.813,0a1.431,1.431,0,1,1,1.43,1.5,1.432,1.432,0,0,1-1.43-1.5Zm6.729,3.73h.8v-1.865c0-.214-.016-.362-.016-.362h.016a1.448,1.448,0,0,0,1.274.682,1.947,1.947,0,0,0,1.881-2.177c0-1.289-.707-2.177-1.824-2.177a1.507,1.507,0,0,0-1.4.756h-.017a2.828,2.828,0,0,0,.017-.3v-.353H312.8v5.8Zm.772-3.705c0-1.06.575-1.5,1.2-1.5.69,0,1.175.583,1.175,1.487,0,.944-.542,1.486-1.2,1.486-.764,0-1.174-.739-1.174-1.478Zm3.869-.017a2.116,2.116,0,0,0,2.2,2.177,2.475,2.475,0,0,0,1.61-.591l-.329-.583a1.981,1.981,0,0,1-1.232.484,1.36,1.36,0,0,1-1.43-1.372H321.3s.024-.238.024-.345a1.769,1.769,0,0,0-1.8-1.947,2.037,2.037,0,0,0-2.078,2.177Zm.846-.484a1.191,1.191,0,0,1,1.216-1.06.98.98,0,0,1,1,1.06Zm3.952,1.429c0,1.043.665,1.167,1.117,1.167a2.181,2.181,0,0,0,.263-.017v-.706a1.311,1.311,0,0,1-.14.008c-.247,0-.444-.09-.444-.591v-4.527h-.8V120.3Zm1.889-.033a1.3,1.3,0,0,0,1.413,1.265,1.438,1.438,0,0,0,1.331-.821h.016a3.191,3.191,0,0,0-.016.329v.394h.739v-2.629a1.477,1.477,0,0,0-1.643-1.627,2.6,2.6,0,0,0-1.552.493l.328.584a2.108,2.108,0,0,1,1.158-.4.808.808,0,0,1,.912.912v.074h-.18c-.7,0-2.506.057-2.506,1.429Zm.8-.041c0-.747,1.084-.788,1.684-.788h.206v.131a1.26,1.26,0,0,1-1.109,1.322A.7.7,0,0,1,324.938,120.227Z"
          fill="#fff"
          fillRule="evenodd"
        />
        <g id="Grupo_2" data-name="Grupo 2">
          <path
            id="Caminho_9"
            data-name="Caminho 9"
            d="M286.362,134.929a4.839,4.839,0,0,0,5.062,4.951,5.177,5.177,0,0,0,3.774-1.514l-.729-1.326a4.282,4.282,0,0,1-2.914,1.27,3.273,3.273,0,0,1-3.344-3.4,3.219,3.219,0,0,1,3.288-3.362,3.83,3.83,0,0,1,2.615,1.083l.859-1.27a4.783,4.783,0,0,0-3.549-1.383A4.86,4.86,0,0,0,286.362,134.929Z"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Caminho_10"
            data-name="Caminho 10"
            d="M296.937,137.077c0,2.373,1.513,2.653,2.541,2.653a5.158,5.158,0,0,0,.6-.037v-1.607a2.853,2.853,0,0,1-.318.019c-.56,0-1.009-.206-1.009-1.345V126.466h-1.812Z"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Caminho_11"
            data-name="Caminho 11"
            d="M301.777,128.316h1.831v-1.85h-1.831v1.85Zm.019,11.339h1.812V130.2H301.8Z"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Caminho_12"
            data-name="Caminho 12"
            d="M318.585,139.655H320.4v-4.446h1.363l2.84,4.446h2.111l-3.493-5.249v-.037l3.138-4.166H324.3l-2.578,3.475H320.4v-7.211h-1.812Z"
            fill="#fff"
            fillRule="evenodd"
          />
          <path id="Caminho_13" data-name="Caminho 13" d="M312.049,135.691l.9.9-3.818,4.446-1.532-1.532Z" fill="#fff" fillRule="evenodd" />
          <path id="Caminho_14" data-name="Caminho 14" d="M312.952,132.112l-.9.9L307.6,129.2l1.532-1.533Z" fill="#fff" fillRule="evenodd" />
          <path id="Caminho_15" data-name="Caminho 15" d="M313.651,136.884h1.278l.444,5.843h-2.167Z" fill="#fff" fillRule="evenodd" />
          <path id="Caminho_16" data-name="Caminho 16" d="M314.928,131.823H313.65l-.444-5.843h2.167Z" fill="#fff" fillRule="evenodd" />
          <path id="Caminho_17" data-name="Caminho 17" d="M311.759,133.714v1.278l-5.844.444V133.27Z" fill="#fff" fillRule="evenodd" />
          <path
            id="Caminho_18"
            data-name="Caminho 18"
            d="M318.544,144.276c0,.539.344.6.577.6a1.1,1.1,0,0,0,.136-.009v-.365a.7.7,0,0,1-.072,0c-.127,0-.229-.046-.229-.305v-2.336h-.412v2.408Zm1.1-1.989h.416v-.419h-.416v.419Zm.005,2.574h.411v-2.145h-.411v2.145Zm1.518,0h.475l.793-2.145H322l-.522,1.45c-.043.119-.072.293-.077.293h-.008s-.03-.174-.072-.293l-.522-1.45h-.436l.8,2.145Zm1.574,0h.411v-.877a1.308,1.308,0,0,1,.051-.386.652.652,0,0,1,.6-.505.58.58,0,0,1,.119.013V142.7a.691.691,0,0,0-.106-.009.734.734,0,0,0-.679.56h-.008s.008-.072.008-.161v-.373h-.4v2.145Zm1.383-1.072a1.092,1.092,0,0,0,1.136,1.123,1.278,1.278,0,0,0,.831-.305l-.169-.3a1.026,1.026,0,0,1-.636.25.7.7,0,0,1-.738-.708h1.564s.013-.123.013-.178a.913.913,0,0,0-.929-1.005,1.051,1.051,0,0,0-1.072,1.124Zm.437-.251a.614.614,0,0,1,.627-.547.505.505,0,0,1,.517.547Z"
            fill="#fff"
            fillRule="evenodd"
          />
        </g>
        <line
          id="Linha_1"
          data-name="Linha 1"
          y2="32.592"
          transform="translate(270.365 113.304)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="22.926"
          strokeWidth="0.48"
        />
      </g>
    </svg>
  );
};
